import { render } from "./MappedFields.vue?vue&type=template&id=4a07d048&scoped=true&lang=pug"
import script from "./MappedFields.vue?vue&type=script&lang=js"
export * from "./MappedFields.vue?vue&type=script&lang=js"

import "./MappedFields.vue?vue&type=style&index=0&id=4a07d048&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a07d048"]])

export default __exports__